import { Badge, Button, Descriptions, Modal, Tooltip } from 'antd';
import dayjs from 'dayjs';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import jobsService from '../../services/jobs.service';
import { InterviewSlotFormModal } from './interview-slot-form-modal';
import { SchedualInterviewModal } from './schedual-interview-modal';

export default function InterviewSlotViewModal(props) {
	const [modalVisible, showModal] = useState(false);
	const [interviewSlotEditVisible, setInterviewSlotEditVisible] = useState(false);

	const onSlotRemove = async () => {
		let res;
		try {
			res = await jobsService.cancelSlot(props.slot.id);
		} catch (e) {
			console.error(e);
			props.onSlotCancelError && (await props.onSlotCancelError(e));
			return;
		}
		props.onSlotCancelSuccess && (await props.onSlotCancelSuccess());
	};

	const buttons = [
		<Button onClick={props.onCancel} className="me-1">
			Close
		</Button>,
		<Tooltip title="this will edit the free slot">
			<Button
				onClick={() => {
					setInterviewSlotEditVisible(true);
				}}
				disabled={props.slot.status !== 'FREE' && props.slot.status !== 'SCHEDULED'}
			>
				Edit Slot
			</Button>
		</Tooltip>
	];

	const due = Date.now() > new Date(props.slot.end).getTime();
	const notFree = props.slot.status !== 'FREE';
	const tooltipTitle = due
		? "Can't assign to this slot becaus it is already due."
		: notFree
		? "Can't assign to this slot because it is not free"
		: 'Assign a candidate to this slot';
	if (props.backOffice) {
		buttons.push(
			<Tooltip title={tooltipTitle}>
				<Button onClick={() => showModal(true)} disabled={due || notFree} type="primary">
					Assign
				</Button>
			</Tooltip>
		);
	} else {
		buttons.push(
			<Tooltip title="this will cancel the free slot">
				<Button
					onClick={() =>
						Modal.confirm({
							title: 'Are you sure you want to Cancel this slot?',
							okText: 'Yes',
							centered: true,
							okType: 'danger',
							cancelText: 'No',
							onOk() {
								onSlotRemove();
							}
						})
					}
					type="primary"
					disabled={props.slot.status !== 'FREE' && props.slot.status !== 'SCHEDULED'}
				>
					Cancel Slot
				</Button>
			</Tooltip>
		);
	}
	const map = {
		SCHEDULED: 'processing',
		CANCELED: 'error',
		FREE: 'success',
		MISSED: 'warning'
	};
	const { candidate } = props.slot;
	return (
		<Modal visible={props.visible} footer={buttons} onCancel={props.onCancel}>
			<Descriptions layout="horizontal" column={{ xs: 1, md: 1 }} className="mb-4" size="small">
				<Descriptions.Item label="Slot Created At">
					{dayjs(props.slot.createdAt).format('DD/MM/YYYY')}
				</Descriptions.Item>

				<Descriptions.Item label="Status">
					<Badge status={map[props.slot.status]} text={props.slot.status} />
				</Descriptions.Item>

				<Descriptions.Item label="Slot date">{dayjs(props.slot.end).format('DD/MM/YYYY')}</Descriptions.Item>

				<Descriptions.Item label="Time">
					{`${dayjs(props.slot.start).format('HH:mm a')} - ${dayjs(props.slot.end).format('HH:mm a')}`}
				</Descriptions.Item>

				<Descriptions.Item label="Online?">
					{props.slot.isOnline === true ? 'Yes' : props.slot.isOnline === false ? 'No' : 'Unknown'}
				</Descriptions.Item>

				<Descriptions.Item label="Company">
					<Link to={`/company/${props.slot.company.id}`}>{props.slot.company.name}</Link>
				</Descriptions.Item>

				<Descriptions.Item label="Job">
					<Link to={`/dashboard/job/${props.slot.job.id}`}>{props.slot.job.title}</Link>
				</Descriptions.Item>

				<Descriptions.Item label="Location">{props.slot.location || 'NA'}</Descriptions.Item>

				<Descriptions.Item label="Interviewer Name">{props.slot.interviewer.name}</Descriptions.Item>

				<Descriptions.Item label="Interviewer Email">{props.slot.interviewer.email}</Descriptions.Item>

				{props.slot.status !== 'FREE' && candidate && (
					<Descriptions.Item label="Candidate">
						<Link to={`/dashboard/candidates/list?candidate=${props.slot.candidate._id}`}>
							{props.backOffice
								? `${candidate.code} | ${candidate.firstName} ${candidate.lastName} | ${candidate.email}`
								: `${candidate.code}`}
						</Link>
					</Descriptions.Item>
				)}

				<Descriptions.Item label="Notes">{props.slot.notes || 'NA'}</Descriptions.Item>
			</Descriptions>

			{props.backOffice && !(due || notFree) && (
				<SchedualInterviewModal
					visible={modalVisible}
					slotId={props.slot.id}
					jobId={props.slot.job._id}
					jobTitle={props.slot.job.title}
					company={props.slot.company}
					onCancel={() => showModal(false)}
					onSuccess={props.onSuccess}
					onError={props.onError}
					candidates={props.candidates || []}
				/>
			)}

			{interviewSlotEditVisible && (
				<InterviewSlotFormModal
					jobs={[props.job]}
					job={props.job}
					onSlotFormCancel={() => setInterviewSlotEditVisible(false)}
					onEditSlotSuccess={props.onEditSlotSuccess}
					onEditSlotError={props.onEditSlotError}
					slot={{ ...props.slot, appointment: { from: props.slot.start, to: props.slot.end } }}
					visible={interviewSlotEditVisible}
				/>
			)}
		</Modal>
	);
}
